import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../lib/api";

export function useResource(name) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/${name}`);
      setItems(data);
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setLoading(false);
    }
  }, [name]);

  useEffect(() => { load(); }, [load]);

  const save = async (body, id) => {
    try {
      const { data } = id ? await api.put(`/${name}/${id}`, body) : await api.post(`/${name}`, body);
      toast.success(id ? "Atualizado!" : "Criado com sucesso!");
      load();
      return data;
    } catch (e) {
      toast.error(formatErr(e));
      return false;
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Excluir este item?")) return;
    try {
      await api.delete(`/${name}/${id}`);
      toast.success("Excluído");
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  return { items, loading, load, save, remove };
}
